import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'subscriptionStatus', standalone: true })
export class SubscriptionStatusPipe implements PipeTransform {
  transform(subscribed: boolean | null): { class: string; button: string } {
    if (subscribed) return { class: 'btn-warning', button: 'Unsubscribe' };
    return { class: 'btn-primary', button: 'Subscribe' };
  }
}
